import React from "react";

function NotFound() {
  return <div>NotFoundsadd</div>;
}

export default NotFound;
